import { LogLevel } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: '9a081cb0-2193-4b06-864d-a99ade954a10',
        authority: 'https://login.microsoftonline.com/9f1c1a16-2ed2-4fff-9162-9dcbc1db9e9d',
        redirectUri: process.env.REACT_APP_REDIRECT_URI ?? 'http://localhost:3000',
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                // switch (level) {
                //     case LogLevel.Error:
                //         console.error(message);
                //         return;
                //     case LogLevel.Info:
                //         console.info(message);
                //         return;
                //     case LogLevel.Verbose:
                //         console.debug(message);
                //         return;
                //     case LogLevel.Warning:
                //         console.warn(message);
                //         return;
                //     default:
                //         return;
                // }
            },
        },
    },
};

export const apiRequest = {
    scopes: [
        // "openid", "profile", "offline_access", 
        "api://9a081cb0-2193-4b06-864d-a99ade954a10/PROCESS_AUTOMATION_SERVICE_ALL"
    ]
};

export default msalConfig;